import React from "react"

interface Props {
    width: number
    height: number
}

export const Spacer: React.FC<Props> = ({ width, height }) => (
    <img
        className="margin_left"
        width={width}
        height={height}
        src="/include/img/creator/spacer.png"
    />
)
